import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { fetchMarketingThreads } from '@/api/agents/marketingAgent'

export function requireMarketingAgent(enabled: boolean, params: { orgSlug: string; projectId: string }) {
  if (!enabled) {
    throw redirect({
      to: '/$orgSlug/$projectId/content/text',
      params: { orgSlug: params.orgSlug, projectId: params.projectId }
    })
  }
}

export const Route = createFileRoute('/_auth/$orgSlug/$projectId/marketing-agent')({
  beforeLoad: ({ context, params }) => {
    const enabled = context.user.userOrgProfile?.enabled_features.marketing_agent ?? false
    requireMarketingAgent(enabled, params)
  },
  loader: async ({ params }) => {
    const projectId = parseInt(params.projectId, 10)
    const { threads } = await fetchMarketingThreads(projectId)
    return { threads }
  },
  component: MarketingAgentLayout
})

function MarketingAgentLayout() {
  return (
    <div className="flex h-full flex-col">
      <Outlet />
    </div>
  )
}
